import { Language } from '@configs/language';

const BASE_LABELS = {
  trsfDtlAlert:
    'You have {{remaining}} to approve this payment. After this time, the exchange rate will be updated to the current rate when it is approved.',
  trsfDtlAlertExpired:
    'The exchange rate has been updated because the time limit to approve this payment has expired.',
  trsfDtlActionTitle: 'Do you want to approve this transfer?',
  trsfDtlActionOriginAmount: 'Origin amount:',
  trsfDtlActionDestinationAmount: 'Destination amount:',
  trsfDtlActionExchangeRate: 'Exchange rate:',
  trsfDtlActionApprove: 'Approve',
  trsfDtlActionReject: 'Reject',
  trsfDtlDetailCardTitle: 'Detail',
  trsfDtlConfigurator: 'Configurator',
  trsfDtlApprover: 'Approver',
  trsfDtlConfiguredDate: 'Date configured',
  trsfDtlApprovalDate: 'Approval date',
  trsfDtlSentDate: 'Sent date',
  trsfDtlRecipient: 'Recipient',
  trsfDtlAccountNumber: 'Account number',
  trsfDtlSwiftCode: 'SWIFT code',
  trsfDtlMovementType: 'Movement type',
  trsfDtlReason: 'Reason',
  trsfDtlAttachment: 'Attachment',
  trsfDtlCep: 'CEP',
  trsfDtlNote: 'Note:',
  trsfDtlActionModalApproveQuestion:
    'Are you sure you want to approve this transfer?',
  trsfDtlModalActionConfirm: 'Yes, approve',
  trsfDtlModalActionReject: 'Yes, reject',
  trsfDtlActionModalClientName: 'Client name:',
  trsfDtlActionModalSendAmount: 'Amount to send:',
  trsfDtlActionModalReceiveAmount: 'Recipient will receive:',
  trsfDtlActionConfirmSnack: 'Done! The transfer has been executed',
  trsfDtlActionRejectSnack: 'You rejected the transfer',
  trsfDtlActionModalRejectQuestion:
    'Are you sure you want to reject this transfer?',
  trsfDtlActionErrorGeneric:
    'An unexpected error occurred. You will be redirected to the transfer details.',
  trsfRateUpdated: 'updated',
  trsfDtlScheduledTransfer: 'Scheduled ransfer',
  trsfDtlForwardTransfer: 'Forward',
  trsfDtlBankTransfer: 'Deferred',
  trsfDtlBalanceTransfer: 'Balance',
};

type LabelsLanguage = keyof typeof BASE_LABELS;

const TRANSFER_DETAILS_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LABELS,
  ES: {
    trsfDtlAlert:
      'Tienes {{remaining}} para aprobar este pago. Pasado este tiempo se mostrará el tipo de cambio actualizado al momento que lo aprueben.',
    trsfDtlAlertExpired:
      'Se actualizó el tipo de cambio, porque se venció el tiempo límite para aprobar este pago.',
    trsfDtlActionTitle: '¿Deseas aprobar esta transferencia?',
    trsfDtlActionOriginAmount: 'Monto origen:',
    trsfDtlActionDestinationAmount: 'Monto destino:',
    trsfDtlActionExchangeRate: 'Tipo de cambio:',
    trsfDtlActionApprove: 'Aprobar',
    trsfDtlActionReject: 'Rechazar',
    trsfDtlDetailCardTitle: 'Detalle',
    trsfDtlConfigurator: 'Configurador',
    trsfDtlApprover: 'Aprobador',
    trsfDtlConfiguredDate: 'Fecha que se configuró',
    trsfDtlApprovalDate: 'Fecha de aprobación',
    trsfDtlSentDate: 'Fecha de envío',
    trsfDtlRecipient: 'Destinatario',
    trsfDtlAccountNumber: 'Número de cuenta',
    trsfDtlSwiftCode: 'Código SWIFT',
    trsfDtlMovementType: 'Tipo de movimiento',
    trsfDtlReason: 'Razón',
    trsfDtlAttachment: 'Documento adjunto',
    trsfDtlCep: 'CEP',
    trsfDtlNote: 'Nota de envío:',
    trsfDtlActionModalApproveQuestion:
      '¿Estas seguro de aprobar esta transferencia?',
    trsfDtlModalActionConfirm: 'Sí, aprobar',
    trsfDtlModalActionReject: 'Sí, rechazar',
    trsfDtlActionModalClientName: 'Nombre del cliente:',
    trsfDtlActionModalSendAmount: '¿Cuánto quieres enviar?:',
    trsfDtlActionModalReceiveAmount: 'El destinatario recibirá:',
    trsfDtlActionConfirmSnack: '¡Listo! Se ejecutó la transferencia',
    trsfDtlActionRejectSnack: 'Rechazaste la transferencia',
    trsfDtlActionModalRejectQuestion:
      '¿Estas seguro de rechazar esta transferencia?',
    trsfDtlActionErrorGeneric:
      'Ocurrió un error inesperado. Serás redirigido a los detalles de la transferencia.',
    trsfRateUpdated: 'actualizado',
    trsfDtlScheduledTransfer: 'Transferencia programada',
    trsfDtlForwardTransfer: 'Futuro',
    trsfDtlBankTransfer: 'Diferido',
    trsfDtlBalanceTransfer: 'Balance',
  },
};

export default TRANSFER_DETAILS_LABELS;
